import AxiosClient from "../AxiosClient";

export const postSearchSalesRecordAPI = (param) =>{
  return AxiosClient.post("/api/salesRecordCollectiveEntry/searchSalesRecord", param);
} 

export const postUpdateSalesRecordAndPrintQrAPI = (param) =>{
  return AxiosClient.post(
    "/api/salesRecordCollectiveEntry/updateSalesRecordAndPrintQr",
    param,
    {
      responseType: "arraybuffer"
    }
  );
} 

export const postUpdateSalesRecordAPI = (param) =>{
  return AxiosClient.post("/api/salesRecordCollectiveEntry/updateSalesRecord", param);
} 
